import { render } from "./SpacesMy.vue?vue&type=template&id=48d8b24b&scoped=true&ts=true"
import script from "./SpacesMy.vue?vue&type=script&lang=ts"
export * from "./SpacesMy.vue?vue&type=script&lang=ts"

import "./SpacesMy.vue?vue&type=style&index=0&id=48d8b24b&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d8b24b"]])

export default __exports__